import { Injectable, TrackByFunction, inject } from '@angular/core';
import {
  LoadableDataSource,
  LocalDataSource,
  PageableDataSource,
  SortableDataSource,
  SuppliersListOption,
} from '@vdms-hq/shared';
import { Observable } from 'rxjs';
import { SuppliersFetcher } from './suppliers-fetcher';
import { Supplier } from '@vdms-hq/api-contract';

@Injectable()
export class SuppliersDataSource
  extends LocalDataSource<Supplier>
  implements SortableDataSource, PageableDataSource, LoadableDataSource
{
  private readonly suppliersFetcher: SuppliersFetcher = inject(SuppliersFetcher);
  public allData$ = this.suppliersFetcher.suppliers$;

  public isLoading$ = this.suppliersFetcher.loading$;

  public trackBy: TrackByFunction<SuppliersListOption> = (index: number, supplier: SuppliersListOption) =>
    supplier.uuid;

  constructor() {
    super();
    this.initialize();
  }

  optionsChanged() {
    this.suppliersFetcher.refresh$.next();
  }

  refresh() {
    this.suppliersFetcher.refresh$.next();
  }

  connect(): Observable<Supplier[]> {
    return this.connection$;
  }

  disconnect(): void {
    super.close();
  }
}
